import React, { Fragment } from "react";

import { Loading } from "components/common";
import {
  Autocomplete,
  Card,
  CardContent,
  Grid,
  Popper,
  TextField,
  IconButton,
  useTheme
} from "@mui/material";
import SearchOutlinedComponent from "components/search/SearchOutlined.component";
import FiltersStationsComponent from "components/tables/filters/FiltersStations.component";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import CachedIcon from "@mui/icons-material/Cached";

const ToolbarTableComponent = (props) => {
  const {
    listClusters,
    handleChangeZone = () => { },
    loading,
    zoneSelected,
    hasFilters = true,
    hasClusters = true,
    onRefresh = () => { },
  } = props
  const { t } = useTranslation();
  const theme = useTheme()

  return (
    <Fragment>
      {loading ? (
        <Loading />
      ) : (
        <Card>
          <CardContent
            sx={{ "&.MuiCardContent-root": { pr: 2.5, pl: 2.5, pb: 2.5, pt: hasFilters ? 1 : 2.5 } }}
          >
            <Grid container display="flex" alignItems='flex-end' spacing={2}>
              <Grid item container display="flex" alignItems='flex-end' spacing={2}
                xs={10}
                sm={11.4}
                md={11.4}
                lg={11.4}>
                {hasClusters && (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4.5}
                    display="flex"
                    alignItems="center"
                  >
                    <Autocomplete
                      multiple
                      noOptionsText={t('No Options')}
                      options={listClusters}
                      value={zoneSelected}
                      loading={loading}
                      name="zone"
                      onChange={(e, value) => handleChangeZone(value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="zone"
                          label={
                            _.isEmpty(zoneSelected)
                              ? t("all-zones")
                              : t("select-one-or-more zones")
                          }
                        />
                      )}
                      size="small"
                      sx={{ width: "100%" }}
                      PopperComponent={({ style, ...props }) => (
                        <Popper
                          {...props}
                          style={{ ...style, zIndex: 20 }}
                        />
                      )}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={4} md={4} lg={4.5}>
                  <SearchOutlinedComponent {...props} />
                </Grid>
                {hasFilters && (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={3}
                    display="flex"
                    justifyContent="end"
                    alignItems="center"
                  >
                    <FiltersStationsComponent {...props} />
                  </Grid>
                )}
              </Grid>
              <Grid
                item
                xs={2}
                sm={0.6}
                md={0.6}
                lg={0.6}
                justifyContent="center"
                alignItems="center"
                display="flex"
              >
                <IconButton
                  onClick={() => onRefresh()}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: 2,
                  }}
                >
                  <CachedIcon
                    sx={{
                      color: "white",
                      "&:hover": { color: theme.palette.primary.main },
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
    </Fragment>
  );
};

export default ToolbarTableComponent;
